import { createAction, createStoreAction } from '@cobuildlab/react-simple-state';
import {
  createPlanCouponEvent,
  createPlanCouponEventError,
  fetchPlanCouponListEvent,
  fetchPlanCouponListEventError,
  fetchPlanEvent,
  fetchPlanEventError,
  planListEvent,
  planListEventError,
} from './plan-events';
import axios from 'axios';
import { PlanListType, PlanStripeCouponListType, PlanStripeCouponType, PlanType } from './plan-types';
import { plansFilterStore } from './plan-store';
import { BACKEND_ENDPOINT } from '../../shared/constants';
import moment from 'moment';
import { SortTableInput } from '../../shared/types/generated';

export const plansFilterStoreAction = createStoreAction(
  plansFilterStore,
  (prev, status: string, isPremium: string) => ({
    ...prev,
    status,
    isPremium,
  }),
);

export const fetchPlanList = createAction(
  planListEvent,
  planListEventError,
  async (data: { page: number; pageSize: number; status: string; isPremium: string }) => {
    const { page, pageSize, status, isPremium } = data;
    const url = `${BACKEND_ENDPOINT}/api/plans`;

    const response = await axios.get<PlanListType>(url, {
      params: { page, pageSize, status, isPremium },
      timeout: 60000,
    });

    return response.data;
  },
);

export const fetchPlan = createAction(
  fetchPlanEvent,
  fetchPlanEventError,
  async (data: { id: string }) => {
    const { id } = data;
    const url = `${BACKEND_ENDPOINT}/api/plans/${id}`;

    const response = await axios.get<PlanType>(url, {
      timeout: 60000,
    });

    return response.data;
  },
);

export const fetchPlanCouponList = createAction(
  fetchPlanCouponListEvent,
  fetchPlanCouponListEventError,
  async (data: {
    page: number;
    pageSize: number;
    status: string;
    expired: boolean;
    orderBy?: SortTableInput;
  }) => {
    const { page, pageSize, status, expired, orderBy } = data;
    const url = `${BACKEND_ENDPOINT}/api/coupons`;

    try {
      const response = await axios.get<PlanStripeCouponListType>(
        url,
        {
          params: {
            page,
            pageSize,
            status,
            includeExpired: expired,
            orderByField: orderBy?.field,
            orderByOrder: orderBy?.order,
          },
          timeout: 60000,
        },
      );

      return response.data;
    } catch (error: any) {
      const msg =
        error?.response?.data?.message ?? 'Error al obtener los cupones';
      throw new Error(msg);
    }
  },
);


export const createPlanCoupon = createAction(
  createPlanCouponEvent,
  createPlanCouponEventError,
  async (data: {
    plans: string[];
    name: string;
    discount: number;
    discountType: string;
    maxRedemptions?: number | null;
    expirationDate?: string | null;
    durationInMonths?: number | null;
    isPublic?: boolean;
    isForSharing?: boolean;
  }) => {
    const { plans } = data;
    const url = `${BACKEND_ENDPOINT}/api/create-coupon`;

    try {
      const response = await axios.post<PlanStripeCouponType>(url, {
        couponName: data.name,
        discount: data.discount,
        discountType: data.discountType,
        maxRedemptions: data.maxRedemptions,
        durationInMonths: data.durationInMonths,
        expirationDate: data?.expirationDate
          ? moment(data.expirationDate).toISOString()
          : null,
        isPublic: data.isPublic,
        isForSharing: data.isForSharing,
        plans,
      });
      return response.data;
    } catch (error: any) {
      const msg = error?.response?.data?.message ?? 'Error al crear el cupón';
      throw new Error(msg);
    }
  },
);
